import React from 'react'
import { toast } from 'react-toastify'
import Btn from './Btn'

interface Props {
  className?: string
  value: boolean
  handler?: (value: boolean) => Promise<void>
  outlined?: boolean
}

const Participation: React.FC<Props> = ({
  className,
  value,
  handler,
  outlined
}) => {
  const [participation, setParticipation] = React.useState(value)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    setParticipation(value)
  }, [value])

  const onClick = async () => {
    setLoading(true)

    try {
      await handler?.(!participation)
      setParticipation(!participation)

      if (!participation) {
        toast.success('Заявка отправлена')
      } else {
        toast.success('Вы отменили участие')
      }
    } catch (e: any) {
      toast.error(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Btn
      outlined={outlined}
      loading={loading}
      className={className}
      onClick={onClick}
    >
      {participation ? 'Отменить участие' : 'Подать заявку'}
    </Btn>
  )
}

export default Participation
